const IGNORE_PATHS = /\/node_modules\/(?!@cbbt)/i;
const stackFilter = (stack) => {
    const lines = stack.split('\n').map((line) => line.trim());
    const topLines = lines.splice(0, 10);
    const additionalLines = lines.filter((line) => !IGNORE_PATHS.test(line));
    return topLines.concat(additionalLines).join('\n');
};
const defaultErrorParser = (error) => {
    if (error instanceof Error) {
        return {
            name: error.name,
            message: error.message,
            stack: stackFilter(error.stack || ''),
            ...(Boolean(error.cause) && { cause: error.cause }),
        };
    }
    else {
        return {
            name: 'unknown',
            message: '',
            stack: '',
            cause: error,
        };
    }
};
const nodeErrorParser = (error) => ({
    ...('code' in error && { code: error.code }),
});
const parserStore = [defaultErrorParser, nodeErrorParser];
const addErrorParser = (parser) => {
    if (!parserStore.includes(parser)) {
        parserStore.push(parser);
    }
};
const parseError = (error) => {
    const parsed = Object.assign({}, ...parserStore.map((parser) => parser(error)));
    return parsed;
};
const chainError = (owner, error) => {
    const parsed = parseError(error);
    parsed.stack = parsed.stack.split('\n').slice(0, 2).join('\n');
    owner.causedBy.push(parsed);
    if (parsed.causedBy) {
        owner.causedBy.push(...parsed.causedBy);
        delete parsed.causedBy;
    }
};
export { addErrorParser, chainError, parseError, };
//# sourceMappingURL=index.js.map